<template>
  <div class="page">

    <!-- ===================== -->
    <!-- Topbar -->
    <!-- ===================== -->
    <header class="topbar">
      <div class="brand">
        <div
          class="logoMark"
          :style="{ '--logo-h': brandLogoSize[currentBrand] || '34px' }"
        >
          <img
            :src="brandLogoMap[currentBrand] || '/throw_logo.png'"
            class="logoImg"
          />
        </div>
      </div>

      <div class="header-actions">
        <button class="feedback-btn" @click="goToFeedback">
          💡 개선/개발 요청
        </button>
        <button
          v-if="mode === 'default' && isRootPath"
          class="admin-btn"
          @click="openModal"
        >
          <span class="icon">📍</span>
          관리자
        </button>
      </div>
    </header>
    <!-- ===================== -->
    <!-- 관리자 인증 모달 -->
    <!-- ===================== -->
    <transition name="fade">
      <div v-if="showModal" class="modal-overlay">
    
        <div class="modal-box">
    
          <h3 class="modal-title">관리자 인증</h3>
    
          <input
            type="password"
            v-model="password"
            class="modal-input"
            placeholder="관리자 비밀번호 입력"
          />
    
          <div v-if="error" class="modal-error">
            비밀번호가 올바르지 않습니다.
          </div>
    
          <div class="modal-actions">
            <button class="modal-cancel" @click="showModal = false">
              취소
            </button>
    
            <button class="modal-confirm" @click="checkPassword">
              확인
            </button>
          </div>
    
        </div>
    
      </div>
    </transition>

    <!-- ===================== -->
    <!-- HOME 화면 -->
    <!-- ===================== -->
    <section v-if="activeView === 'home'" class="hero">
      <div class="heroInner">
        <div class="panel">
          <div class="panelHeader">
            <div>
              <div class="panelTitle">업무 선택</div>
              <div class="panelDesc">보험금 청구부터 예상 보험금 시뮬레이션까지 한 번에 관리합니다.</div>
            </div>
          </div>

          <div class="grid">

            <div class="card" @click="activeView = 'claim'">
              <div class="cardTitle">📄 보험금 청구서 자동 작성</div>
              <div class="miniHint">
                보험사별 청구서 PDF 자동 생성
              </div>
            </div>

            <div class="card" @click="activeView = 'disease'">
              <div class="cardTitle titleRow">
                🧠 청구금액 AI
                <span class="badge">준비중</span>
              </div>
              <div class="miniHint">
                질병명(코드) 기반 보험금 AI 분석
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>


    <!-- ===================== -->
    <!-- 내부 페이지 렌더링 -->
    <!-- ===================== -->
    <section v-else class="hero hero-wide">
      <div class="heroInner heroInner-wide">
    
        <div style="margin-bottom:0px;">
          <button class="btn" @click="activeView = 'home'">
            ← 업무선택
          </button>
        </div>
    
        <component
          :is="currentComponent"
          :brand="currentBrand"
        />
    
      </div>
    </section>

  </div>
</template>

<script>
import ClaimPage from "@/views/ClaimPage.vue"
import DiseaseAnalyzer from "@/views/DiseaseAnalyzer.vue"

/* ===============================
   브랜드 로고 설정
================================= */
const brandLogoMap = {
  kli: '/kli_logo.png',
  304: '/304_logo.png',
  sg: '/sg_logo.png',
  hb: '/hb_logo.png',
  cnc: '/cnc_logo.png',
  moa: '/moa_logo.png',
  sng: '/synergy_logo.png',
}

const brandLogoSize = {
  throw: '34px',
  kli: '42px',
  304: '62px',
  sg: '120px',
  hb: '65px',
  cnc: '38px',
  moa: '84px',
  sng: '62px',
}

export default {
  name: "HomeBoard",

  components: {
    ClaimPage,
    DiseaseAnalyzer
  },

  data() {
    return {
      activeView: "home",
      mode: "default",
      showModal: false,
      password: "",
      error: false
    }
  },
  mounted() {
  
    if (this.$route.path !== "/") {
      this.activeView = "claim"
    }
  
  },
  methods: {
    openModal() {
      this.showModal = true
      this.password = ""
      this.error = false
    },

    checkPassword() {
      if (this.password === "6276") {
        this.showModal = false
        this.error = false
        this.$router.push('/admin/coords')
      } else {
        this.error = true
      }
    },

    goToFeedback() {
      window.open(
        "https://docs.google.com/forms/d/e/1FAIpQLSd-1pd_IDDl2gcjBokciwdoTiueWIxqZJLyvvJK4gX1upkiVQ/viewform",
        "_blank"
      )
    }
  },

  computed: {
    currentBrand() {
      return this.$route.meta.brand || "throw"
    },
    
    isRootPath() {
      return this.$route.path === "/"
    },

    currentComponent() {
      if (this.activeView === "claim") return "ClaimPage"
      if (this.activeView === "disease") return "DiseaseAnalyzer"
      return null
    },

    brandLogoMap() {
      return brandLogoMap
    },

    brandLogoSize() {
      return brandLogoSize
    }
  }
}
</script>

<style>

/* ==============================
   THROW Homeboard Style
============================== */

/* 페이지 배경 */
.page {
  min-height: 100vh;
  background:
    radial-gradient(1000px 500px at 50% -20%, rgba(255,255,255,.95), rgba(255,255,255,0)),
    linear-gradient(180deg, #eaf2ff 0%, #f4f8ff 55%, #ffffff 100%);
  color: #111827;
}

/* ==============================
   Topbar
============================== */

.topbar {
  height: 74px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  position: sticky;
  top: 0;
  z-index: 20;

  background: rgba(255,255,255,0.6);
  border-bottom: 1px solid rgba(17,24,39,.06);
}

.brand {
  display: flex;
  align-items: center;
}

.logoMark {
  height: var(--logo-h);
  display: flex;
  align-items: center;
}

.logoImg {
  height: var(--logo-h);
  object-fit: contain;
}

.header-actions {
  display: flex;
  gap: 14px;
}

/* 버튼 */
.feedback-btn {
  padding: 8px 20px;
  border-radius: 999px;
  border: 1.5px solid #2563eb;
  background: white;
  color: #2563eb;
  font-weight: 600;
  cursor: pointer;
  transition: 0.25s ease;
}

.feedback-btn:hover {
  background: #2563eb;
  color: white;
}

.admin-btn {
  padding: 8px 20px;
  border-radius: 999px;
  border: none;
  font-weight: 600;
  cursor: pointer;

  background: linear-gradient(135deg, #4f8cff, #2563eb);
  color: white;

  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.35);
  transition: 0.25s ease;
}

.admin-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(37, 99, 235, 0.45);
}

/* ==============================
   Hero
============================== */

.hero {
  padding: 25px 20px 80px;
}

.heroInner {
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
}

.title {
  font-size: 48px;
  font-weight: 800;
  letter-spacing: -2px;
  margin-bottom: 18px;
}

.subtitle {
  font-size: 17px;
  color: #4b5563;
  margin-bottom: 50px;
  line-height: 1.6;
}

/* ==============================
   Panel (Glass)
============================== */

.panel {
  background: rgba(255,255,255,0.7);

  border: 1px solid rgba(255,255,255,0.6);
  border-radius: 26px;

  padding: 40px;
  box-shadow:
    0 20px 60px rgba(17,24,39,.08),
    inset 0 1px 0 rgba(255,255,255,.7);
}

.panelHeader {
  margin-bottom: 30px;
}

.panelTitle {
  font-size: 20px;
  font-weight: 800;
}

.panelDesc {
  margin-top: 6px;
  font-size: 13px;
  color: #6b7280;
}

/* ==============================
   Grid
============================== */

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

/* ==============================
   Card
============================== */

.card {
  padding: 30px;
  border-radius: 22px;

  background: linear-gradient(
    145deg,
    rgba(255,255,255,0.85),
    rgba(255,255,255,0.65)
  );

  border: 1px solid rgba(17,24,39,.06);

  box-shadow:
    0 12px 30px rgba(17,24,39,.06),
    inset 0 1px 0 rgba(255,255,255,.7);

  cursor: pointer;
  transition: all 0.25s ease;
}

.card:hover {
  transform: translateY(-6px);
  box-shadow:
    0 20px 50px rgba(17,24,39,.12),
    inset 0 1px 0 rgba(255,255,255,.8);
}

.cardTitle {
  font-size: 18px;
  font-weight: 800;
  margin-bottom: 10px;
}

.miniHint {
  font-size: 14px;
  color: #6b7280;
}

/* ==============================
   Back button
============================== */

.btn {
  padding: 10px 18px;
  border-radius: 999px;
  border: 1px solid rgba(17,24,39,.12);
  background: white;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}

.btn:hover {
  background: #f3f4f6;
}

/* ===============================
   THROW Glass Modal
=============================== */

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(17,24,39,0.35);

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-box {
  width: 360px;
  padding: 36px 28px;
  border-radius: 24px;

  background: rgba(255,255,255,0.75);

  border: 1px solid rgba(255,255,255,0.7);

  box-shadow:
    0 30px 80px rgba(17,24,39,.25),
    inset 0 1px 0 rgba(255,255,255,.8);

  text-align: center;
}

.modal-title {
  font-size: 20px;
  font-weight: 800;
  margin-bottom: 20px;
}

.modal-input {
  width: 100%;
  height: 46px;
  border-radius: 14px;
  border: 1px solid #e5e7eb;
  padding: 0 14px;
  font-size: 14px;
  outline: none;
  transition: .2s;
}

.modal-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37,99,235,.12);
}

.modal-error {
  margin-top: 12px;
  font-size: 13px;
  color: #dc2626;
}

.modal-actions {
  margin-top: 24px;
  display: flex;
  gap: 10px;
}

.modal-cancel {
  flex: 1;
  height: 42px;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: white;
  cursor: pointer;
  font-weight: 600;
}

.modal-confirm {
  flex: 1;
  height: 42px;
  border-radius: 999px;
  border: none;
  font-weight: 700;
  cursor: pointer;

  background: linear-gradient(135deg, #4f8cff, #2563eb);
  color: white;

  box-shadow: 0 6px 16px rgba(37,99,235,.35);
}

.modal-confirm:hover {
  transform: translateY(-2px);
}

/* 애니메이션 */
.fade-enter-active,
.fade-leave-active {
  transition: all .25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: scale(.95);
}

.heroInner-wide {
  max-width: 1600px;  /* 기존 1000 → 1400 */
}

.hero-wide {
  padding: 24px 0px 0px;
}

.titleRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.badge {
  font-size: 11px;
  font-weight: 700;

  padding: 3px 10px;
  border-radius: 999px;

  color: white;

  background: linear-gradient(135deg,#ef4444,#dc2626);

  box-shadow: 0 4px 10px rgba(220,38,38,.25);
}

/* ==============================
   Responsive
============================== */

@media (max-width: 900px) {
  .title {
    font-size: 42px;
  }

  .grid {
    grid-template-columns: 1fr;
  }

  .panel {
    padding: 26px;
  }
  .feedback-btn,
  .admin-btn {
    padding: 6px 12px;
    font-size: 12px;
    border-radius: 20px;
    white-space: nowrap; /* 줄바꿈 방지 */
  }
}
</style>